import React, { memo, useMemo } from "react";
import Cancel from "./cancel";
import Accept from "./accept";
import Sending from "./sending";
import Delivered from "./delivered";

const Actions = props => {
    const { data, mutate } = props;

    const buttonsList = useMemo(() => {
        return {
            "accept": <Accept data={data} mutate={mutate} />,
            "cancel": <Cancel data={data} mutate={mutate} />,
            "sending": <Sending data={data} mutate={mutate} />,
            "delivered": <Delivered data={data} mutate={mutate} />
        }

        // eslint-disable-next-line
    }, [data])

    const actionsList = useMemo(() => {
        const output = [];

        if (data?.status_id === 2 && data.order.status_id === 1)
            output.push("cancel");

        if (data?.status_id === 2 && data.order.status_id === 1)
            output.push("accept");

        if (data?.order?.status_id === 3 && data.accept_change_by_customer !== false)
            output.push("sending");

        return output;
    }, [data])

    return (
        actionsList.map((action, i) => (
            <React.Fragment key={`order-action-${i}`}>
                {buttonsList[action]}
            </React.Fragment>
        ))
    )
}

export default memo(Actions);